{{ text }}
<ng-content></ng-content>

